/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { Link,useLocation } from 'react-router-dom';
import Login from './login';
import News from './news';
import MenuItems from './MenuItems';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXTwitter,faWhatsapp} from  "@fortawesome/free-brands-svg-icons";
import assetUrl from '../../services/assetUrl';
const normalLogo = assetUrl('/ncet_assets/images/NGE-Logo.png');
// import stickyLogo from '../../assets/images/logos/au.png';
import '../Header/header.scss';

const Header = (props) => {
	const { topbarEnable, menuCategoryEnable, headerClass, parentMenu, headerNormalLogo, headerStickyLogo } = props;

	const [menuOpen, setMenuOpen] = useState(false)
	const [isVisible, setIsVisible] = useState(false);
	const location = useLocation();

	useEffect(() => {
		// Sticky is displayed after scrolling for 100 pixels
		const toggleVisibility = () => {
			if (window.pageYOffset > 100) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		};

		window.addEventListener("scroll", toggleVisibility);

		return () => window.removeEventListener("scroll", toggleVisibility);
	}, []);

	return (
		<>
			<header id="react-header" className={headerClass ? headerClass : 'react-header react-header-three'}>
				<div className={isVisible ? 'header-area react-sticky' : 'header-area'}>
					<div className="topbar-area style1" style={{ padding: '0', background: '#ffffff', width: '100%' }}>
						<div className="container">
							<div className="react-main-menu">
								<nav className="custom-unified-header">
									<div className="menu-toggle logo-section">
										<div className="logo">
											{
												isVisible ?
													<Link to="/" className="logo-text">
														<img src={assetUrl(normalLogo)} alt="" style={{ height: '90px' }} />
													</Link> :
													<Link to="/" className="logo-text">
														<img src={assetUrl(normalLogo)} alt="" style={{ height: '90px' }} />
													</Link>
											}
										</div>
										<button type="button" id="menu-btn" className={menuOpen ? "mobile-menu-btn open" : "mobile-menu-btn"} onClick={() => { setMenuOpen(!menuOpen) }}>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
											<span className="icon-bar"></span>
										</button>
									</div>

									<div className={`menu-section ${menuOpen ? "react-inner-menus menu-open" : "react-inner-menus"}`}>
										<ul id="backmenu" className="react-menus react-sub-shadow">
											<MenuItems parentMenu={parentMenu} />
										</ul>
									</div>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
}

export default Header;